import React from "react";
import {Cell} from "../../../elements/Tables";
import {kpiBriefDescription, KpiTooltip} from "../../../performance/Kpi";
import {NameContainer, NewIdeasContainer, RankContainer, StatContainer} from "./TableItems";
import styled from "styled-components";

const HeadingContainer = styled.div`
    display: flex;
    font-weight: bold;
`;

function showRankColumn(firstGroupingName) {
    return (firstGroupingName === "author" || firstGroupingName === "author-company");
}

export const TableHeadings = ({firstGroupingName, kpi, currency, columns}) => {
    const showRank = showRankColumn(firstGroupingName);
    return (
        <HeadingContainer className="t-table-headings">
            {showRank ? <RankContainer className="t-heading-rank">Rank</RankContainer> : null}
            <NameContainer className="t-heading-name">Name</NameContainer>
            <NewIdeasContainer className="t-heading-new-ideas">
                <Cell right>New Ideas</Cell>
            </NewIdeasContainer>
            {
                columns.map(c => {
                    const isKpi = c.name === kpi;
                    return (<StatContainer key={c.name}
                                           showKpiBackgroundColour={false}
                                           className={`t-heading-${c.name}`}>
                            <Cell right>
                                {kpiBriefDescription(c.name, currency)}
                                {isKpi ? <KpiTooltip/> : null}
                            </Cell>
                        </StatContainer>
                    );
                })
            }
        </HeadingContainer>
    );
};